import { Row, Col, Card, Button } from 'react-bootstrap';
import { PaymentButton } from '../../payment';

interface ApolloData {
  id: number;
  booking_reference?: string;  // New: Unique reference like 'APOLLO-2024-0000001'
  Name: string;
  emailId: string;
  phoneNumber: string;
  bookingDate: string;
  bookingTime: string;
  state: string;
  city: string;
  clinicId: string;
  clinicName: string;
  clinicAddress: string;
  clinicPin: string;
  CRMClientId: string;
  EmployeeId: string;
  Fee?: number;
  gst?: number;
  totalfee?: number;
  paymentstatus?: string;  // Deprecated: Use payment_status from payment_status table
  payment_status?: string;  // New: From payment_status table ('pending', 'paid', 'failed', 'refunded')
  createdAt: string;
  updatedAt: string;
}

type Props = {
  requests: ApolloData[];
  onAddRequest: () => void;
};

const ApolloList: React.FC<Props> = ({ requests, onAddRequest }) => {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h6 className="mb-0">Your Bookings ({requests.length})</h6>
        <Button variant="primary" size="sm" onClick={onAddRequest}>
          + New Booking
        </Button>
      </div>
      <Row>
        {requests.map((request) => {
          return (
            <Col md={12} key={request.id} className="mb-4">
              <Card className="shadow-sm border-0" style={{ borderLeft: '4px solid #0d6efd' }}>
                <Card.Header style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }} className="text-white">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Health Checkup Appointment</h5>
                    {request.booking_reference && (
                      <span className="badge bg-light text-dark">#{request.booking_reference}</span>
                    )}
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={8}>
                      <div className="mb-4">
                        <h6 className="text-muted mb-3" style={{ 
                          borderBottom: '2px solid #667eea', 
                          paddingBottom: '8px',
                          fontWeight: '600'
                        }}>Contact Information</h6>
                        <div className="d-flex align-items-start mb-2">
                          <span style={{ minWidth: '80px', color: '#6c757d' }}>Name:</span>
                          <span className="fw-semibold">{request.Name}</span>
                        </div>
                        <div className="d-flex align-items-start mb-2">
                          <span style={{ minWidth: '80px', color: '#6c757d' }}>Email:</span>
                          <span className="text-break">{request.emailId}</span>
                        </div>
                        <div className="d-flex align-items-start mb-2">
                          <span style={{ minWidth: '80px', color: '#6c757d' }}>Phone:</span>
                          <span className="fw-semibold">{request.phoneNumber}</span>
                        </div>
                      </div>

                      <div className="mb-4">
                        <h6 className="text-muted mb-3" style={{ 
                          borderBottom: '2px solid #764ba2', 
                          paddingBottom: '8px',
                          fontWeight: '600'
                        }}>Location</h6>
                        <div className="d-flex align-items-start mb-2">
                          <span style={{ minWidth: '60px', color: '#6c757d' }}>State:</span>
                          <span className="fw-semibold">{request.state}</span>
                        </div>
                        <div className="d-flex align-items-start mb-2">
                          <span style={{ minWidth: '60px', color: '#6c757d' }}>City:</span>
                          <span className="fw-semibold">{request.city}</span>
                        </div>
                      </div>
                    </Col>
                    
                    <Col md={4}>
                      {/* Appointment Date Card */}
                      <div className="p-4 text-center h-100" style={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        borderRadius: '12px',
                        color: 'white',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        minHeight: '200px'
                      }}>
                        <div className="text-uppercase small mb-3" style={{ letterSpacing: '1px', opacity: 0.9 }}>
                          Appointment Scheduled
                        </div>
                        <div>
                          <div style={{ fontSize: '3rem', fontWeight: 'bold', lineHeight: 1 }}>
                            {new Date(request.bookingDate).getDate()}
                          </div>
                          <div style={{ fontSize: '1.1rem', opacity: 0.9, marginTop: '8px' }}>
                            {new Date(request.bookingDate).toLocaleString('default', { month: 'short' }).toUpperCase()} {new Date(request.bookingDate).getFullYear()}
                          </div>
                          <div style={{ 
                            fontSize: '1.3rem', 
                            fontWeight: '600', 
                            marginTop: '16px',
                            paddingTop: '16px',
                            borderTop: '1px solid rgba(255,255,255,0.3)'
                          }}>
                            {request.bookingTime}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  
                  <div className="mb-4">
                    <h6 className="text-muted mb-3" style={{ 
                      borderBottom: '2px solid #28a745', 
                      paddingBottom: '8px',
                      fontWeight: '600'
                    }}>Clinic Details</h6>
                    <div className="bg-light p-3 rounded">
                      <p className="mb-2"><strong>Name:</strong> {request.clinicName}</p>
                      <p className="mb-2"><strong>Address:</strong> {request.clinicAddress}</p>
                      <p className="mb-0"><strong>PIN:</strong> {request.clinicPin}</p>
                    </div>
                  </div>
                  
                  {/* Payment Details Section */}
                  {(request.Fee !== undefined && request.Fee > 0) && (
                    <div className="mb-3">
                      <div className="p-4 rounded" style={{
                        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                        border: '1px solid #dee2e6'
                      }}>
                        <h6 className="mb-3" style={{ fontWeight: '600', color: '#495057' }}>Payment Details</h6>
                        <Row className="align-items-center">
                          <Col md={7}>
                            <div className="d-flex justify-content-between mb-2">
                              <span>Appointment Fee:</span>
                              <span className="fw-semibold">₹{request.Fee?.toLocaleString('en-IN')}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                              <span>GST (18%):</span>
                              <span className="fw-semibold">₹{request.gst?.toLocaleString('en-IN')}</span>
                            </div>
                            <hr className="my-2" />
                            <div className="d-flex justify-content-between">
                              <span className="fs-5 fw-bold">Total Amount:</span>
                              <span className="fs-4 fw-bold" style={{ color: '#667eea' }}>
                                ₹{request.totalfee?.toLocaleString('en-IN')}
                              </span>
                            </div>
                          </Col>
                          <Col md={5} className="text-end">
                            {(request.payment_status?.toLowerCase() === 'paid' || request.paymentstatus?.toLowerCase() === 'paid') ? (
                              <div className="d-inline-block px-4 py-3 rounded" style={{
                                background: '#28a745',
                                color: 'white',
                                fontSize: '1.1rem',
                                fontWeight: '600'
                              }}>
                                ✓ Payment Completed
                              </div>
                            ) : (request.payment_status?.toLowerCase() === 'failed') ? (
                              <div className="d-flex flex-column align-items-end gap-2">
                                <div className="px-4 py-2 rounded" style={{
                                  background: '#dc3545',
                                  color: 'white',
                                  fontWeight: '600'
                                }}>
                                  ✗ Payment Failed
                                </div>
                                  <PaymentButton
                                    paymentData={{
                                      bookingId: request.id,
                                      bookingReference: request.booking_reference || `APOLLO-TEMP-${request.id}`,
                                      bookingType: 'APOLLO',
                                      name: request.Name,
                                      email: request.emailId,
                                      phone: request.phoneNumber,
                                      amount: request.Fee || 0,
                                      gst: request.gst || 0,
                                      totalAmount: request.totalfee || 0,
                                      description: `Health Checkup at ${request.clinicName}`,
                                    }}
                                    variant="warning"
                                    size="sm"
                                  >
                                    Retry Payment
                                  </PaymentButton>
                                </div>
                              ) : (
                                <PaymentButton
                                  paymentData={{
                                    bookingId: request.id,
                                    bookingReference: request.booking_reference || `APOLLO-TEMP-${request.id}`,
                                    bookingType: 'APOLLO',
                                    name: request.Name,
                                    email: request.emailId,
                                    phone: request.phoneNumber,
                                    amount: request.Fee || 0,
                                    gst: request.gst || 0,
                                    totalAmount: request.totalfee || 0,
                                    description: `Health Checkup at ${request.clinicName}`,
                                  }}
                                  variant="success"
                                  size="lg"
                                >
                                  Pay Now
                                </PaymentButton>
                              )}
                            </Col>
                          </Row>
                        </div>
                      </div>
                    )}
                    
                    <div className="text-muted small mt-3" style={{ 
                      borderTop: '1px solid #dee2e6', 
                      paddingTop: '12px' 
                    }}>
                      <small>📅 Booked on: {new Date(request.createdAt).toLocaleString()}</small>
                    </div>
                  </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export { ApolloList };
export type { ApolloData };
